import { render, staticRenderFns } from "./ApplyLeaveAppRightToAppealPg.vue?vue&type=template&id=0a963b8f&scoped=true"
import script from "./ApplyLeaveAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./ApplyLeaveAppRightToAppealPg.vue?vue&type=script&lang=ts"
import style0 from "./ApplyLeaveAppRightToAppealPg.vue?vue&type=style&index=0&id=0a963b8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a963b8f",
  null
  
)

export default component.exports